<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '500px' }"
  (onHide)="closeDialog()"
>
  <!-- Header Section -->
  <div class="text-center py-4 px-3 rounded mb-3 bg-primary">
    <div class="fw-bold mb-1 text-white" style="font-size: 1.75rem;">
      {{ headerTitle }}
    </div>
    <div class="text-white">
      {{ headerSubtitle }}
    </div>
  </div>

  <!-- Key-Value Data Section -->
  <div class="px-3 py-2 border rounded mb-3">
    <div
      class="d-flex justify-content-between align-items-center py-2 border-bottom"
      *ngFor="let item of data; let last = last"
      [class.border-bottom]="!last"
    >
      <div class="fw-bold text-dark">{{ item.key }}</div>
      <div class="text-muted">{{ item.value }}</div>
    </div>
  </div>

  <!-- Logo Section -->
  <div class="text-center py-3">
    <img
      [src]="logoUrl"
      alt="Logo"
      class="img-fluid"
      style="max-height: 60px"
    />
    <div class="text-muted small mt-2">{{ subText }}</div>
  </div>

  <ng-template pTemplate="footer">
    <hr />
    <div class="d-flex justify-content-center gap-2">
      <button
        class="btn btn-outline-secondary"
        (click)="closeDialog()"
      >
        Close
      </button>
      <button
        class="btn btn-primary"
        (click)="download()"
      >
        Download
      </button>
    </div>
  </ng-template>
</p-dialog>
